/** Libellés FR pour les enums SAV B2B (constants API en snake_case UPPER) */

export const MOTIF_LABELS = {
  RETARD_ORGA_RH: "Retard (organisationnel / RH)",
  RETARD_ALEA_ROUTE: "Retard (aléa route)",
  ERREUR_OUBLI: "Erreur / oubli",
  PROBLEME_RECUP: "Problème récup",
  ERREUR_ADRESSE_CONTACT: "Erreur adresse / contact",
  ERREUR_CONTENU_DEVIS: "Erreur contenu devis",
  QUALITE: "Qualité",
};

export const SERVICE_LABELS = {
  LOGISTIQUE: "Logistique",
  GESTION_CLIENTELE: "Gestion de clientèle",
  PRODUCTION: "Production",
  SERVICE: "Service",
};

export const STATUT_LABELS = {
  A_TRAITER: "À traiter",
  EN_COURS: "En cours",
  REGLE: "Réglé",
};

export const CANAL_LABELS = {
  COMPAGNON: "Compagnon",
  CLIENT: "Client",
  INTERNE: "Interne",
  IMPORT: "Import",
};

export const GESTE_LABELS = {
  AUCUN: "Aucun",
  AVOIR: "Avoir",
  REMISE_IMMEDIATE: "Remise immédiate",
  REMISE_PROCHAINE_COMMANDE: "Remise prochaine commande",
  REFACTION_FACTURE: "Refaction facture",
  CARTE_EXCUSE: "Carte d'excuse",
};

export const labelFor = (map, key) => map[key] || key || "—";

export const euros = (centimes) =>
  centimes != null && centimes !== ""
    ? (centimes / 100).toFixed(2).replace(".", ",") + " €"
    : null;
